// Action Constants
export const DOC_PAGE_CLOSE_DRAWER = "DOC_PAGE/CLOSE_DRAWER";
export const DOC_PAGE_OPEN_DRAWER = "DOC_PAGE/OPEN_DRAWER";

// Interfaces
interface DocPageState {
	isDrawerOpen: boolean;
}

// Initial State
const docPageInitialState: DocPageState = {
	isDrawerOpen: false,
};

export default (state: DocPageState = docPageInitialState, action): DocPageState => {
	switch (action.type) {
		case DOC_PAGE_CLOSE_DRAWER:
			return {
				...state,
				isDrawerOpen: false,
			};

		case DOC_PAGE_OPEN_DRAWER:
			return {
				...state,
				isDrawerOpen: true,
			};

		default:
			return state;
	}
};

// Actions
export const actions = {
	openDrawer: () => dispatch => {
		dispatch({
			type: DOC_PAGE_OPEN_DRAWER,
		});
	},
	closeDrawer: () => dispatch => {
		dispatch({
			type: DOC_PAGE_CLOSE_DRAWER,
		});
	},
};

const docPageState = state => state.docPage as DocPageState;

// Selectors
export const selectors = {
	isDrawerOpen: state => docPageState(state).isDrawerOpen,
};



// WEBPACK FOOTER //
// ./src/reducers/doc_page.ts